export default __webpack_public_path__ + "static/media/plus-header.4a007f89.svg";